<template>
    <div class="sidebarTabs w-full md:w-1/5 flex flex-col text-left">
        <a to="/dashboard/perfil" class="button text-left cursor-pointer" :class="{ active: isPage == 'perfil' }"  @click="onClick('DashboardPerfil', 'perfil')" >
            <div class="border-b py-3 px-0">
                <span class="text">{{dashboardTranslate[language].sidebar.profile}}</span>
            </div>
        </a>
        <a to="/dashboard" class="button text-left cursor-pointer" :class="{ active: isPage == 'suscripción' }" @click="onClick('DashboardSubscription', 'suscripción')" >
            <div class="border-b py-3 px-0">
                <span class="text">{{dashboardTranslate[language].sidebar.subscrition}}</span>
            </div>
        </a>
        <a to="/dashboard/pago" class="button text-left cursor-pointer" :class="{ active: isPage == 'pagos' }"  @click="onClick('DashboardPago', 'pagos')">
            <div class="border-b py-3 px-0">
                <span class="text">{{dashboardTranslate[language].sidebar.payment}}</span>
            </div>
        </a>
        <a href="http://www.vivaaerobus.com/" class="button border-b py-3 text-left text-green-400 font-semibold flex items-center cursor-pointer" @click="onClick('DashboardSubscription', 'dashboard')" >
                <span class="text">{{dashboardTranslate[language].sidebar.goto}}</span>
            <span><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg></span>
        </a>
    </div>
</template>

<script>
import { dashboardTranslate } from '@/translations/Dashboard.js'
import { computed } from '@vue/reactivity';
import { useRouter } from 'vue-router';
import { dataLayerClickOnMenu } from '@/pixels/datalayer.js'

  export default {
    props: ['isPage'],
    setup(){
       const language = computed(() => {
            return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
        })
        const router = useRouter()
        const onClick = ( routeName, label ) => {
            dataLayerClickOnMenu( label)
            router.push({ name: routeName  })
        }

        return { language, dashboardTranslate, onClick }
    }
  };
</script>

<style scoped>
.sidebarTabs > .button:hover span.text{
    @apply font-bold text-green-500 block py-1 px-3;
    border-left: 5px solid #8cd400;
}
.sidebarTabs > .button span.text {
    @apply block py-1 px-3;
    border-left: 5px solid transparent;
}
.sidebarTabs .button.active span {
    @apply font-bold text-green-500 block py-1 px-3;
    border-left: 5px solid #8cd400;
}
</style>